import { Link } from 'react-router-dom';
import type { DramaItem } from '@/mocks/dramas';

interface DramaCardProps {
  drama: DramaItem;
  size?: 'small' | 'normal';
}

const DramaCard = ({ drama, size = 'normal' }: DramaCardProps) => {
  return (
    <Link
      to={`/drama/${drama.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg ${size === 'small' ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={drama.posterSrc}
          alt={`${drama.title} - 免费在线观看`}
          title={`${drama.title} 高清在线免费观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          <span className="inline-block px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
            {drama.rating}
          </span>
        </div>
        {drama.status === '更新中' && (
          <div className="absolute top-2 right-2">
            <span className="inline-block px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
              更新中
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-foreground-900 font-semibold text-sm md:text-base truncate">
            {drama.title}
          </h3>
          <p className="text-foreground-500 text-xs mt-1">
            {drama.category} · {drama.year} · {drama.episodeCount}集
          </p>
        </div>
      </div>
    </Link>
  );
};

export default DramaCard;